import React, { useEffect, useState } from "react";
import Layout from "../../elements/Layout";
import { getPropertyById } from "../../utils/api/api";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FaBuilding, FaRegMoneyBillAlt, FaFileContract } from "react-icons/fa";

const ViewProperty = () => {
    const [property, setProperty] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getProperty = async () => {
            try {
                const response = await getPropertyById(id);
                setProperty(response.property);
            } catch (error) {
                console.log(error);
            }
        };

        getProperty();
    }, [id]);

    if (!property) {
        return <Layout>Loading...</Layout>;
    }

    return (
        <Layout>
            <motion.div
                className="max-w-4xl mx-auto p-8 bg-gray-100 backdrop-blur-lg rounded-2xl border border-gray-200 dark:bg-gray-900/80"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                {/* Header Section */}
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
                        Property Profile
                    </h1>
                    <p className="text-gray-500 dark:text-gray-400">Detailed insights & information</p>
                </div>

                <div className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center">
                        <FaBuilding className="mr-2 text-blue-500" /> General Information
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                            { label: "Property Number", value: property.property_number },
                            { label: "Title Number", value: property.title_number },
                            { label: "Status", value: property.status.replace("_", " ") },
                            { label: "Created At", value: new Date(property.createdAt).toLocaleDateString() },
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                className="bg-white/90 p-4 rounded-xl  border border-gray-100 dark:bg-gray-800 dark:border-gray-700"
                                whileHover={{ scale: 1.02 }}
                            >
                                <p className="text-sm text-gray-500 dark:text-gray-400">{item.label}</p>
                                <p className="text-[15px] font-medium text-gray-800 dark:text-white">{item.value}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {property.sale_info ? (
                    <div className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center">
                            <FaRegMoneyBillAlt className="mr-2 text-green-500" /> Sale Information
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <motion.div
                                className="bg-white/90 p-4 rounded-xl  border border-gray-100 dark:bg-gray-800 dark:border-gray-700"
                                whileHover={{ scale: 1.02 }}
                            >
                                <p className="text-sm text-gray-500 dark:text-gray-400">Amount</p>
                                <p className="text-lg font-medium text-gray-800 dark:text-white">
                                    KES {Number(property.sale_info.amount).toLocaleString()}
                                </p>
                            </motion.div>

                            <motion.div
                                className="bg-white/90 p-4 rounded-xl  border border-gray-100 dark:bg-gray-800 dark:border-gray-700"
                                whileHover={{ scale: 1.02 }}
                            >
                                <div className="flex items-center w-full justify-between">
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Customer</p>
                                    <button
                                        onClick={() => navigate(`/dashboard/customers/${property.sale_info.order.customer.id}/view`)}
                                        className="bg-green-100 text-green-500 text-[14px] px-3 rounded-md py-[2px]">
                                        View
                                    </button>
                                </div>
                                <p className="text-lg font-medium text-gray-800 dark:text-white">
                                    {property.sale_info.order.customer.first_name} {property.sale_info.order.customer.last_name}
                                </p>
                            </motion.div>
                        </div>

                        <div className="mt-6">
                            <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center">
                                <FaFileContract className="mr-2 text-purple-500" /> Contracts
                            </h3>
                            <div className="space-y-4">
                                {property.sale_info.order.contracts.map((contract) => (
                                    <motion.div
                                        key={contract.id}
                                        className="bg-white/90 p-4 rounded-xl  border-l-4 border-blue-500 dark:bg-gray-800 dark:border-blue-400"
                                        whileHover={{ scale: 1.02 }}
                                    >
                                        <div className="flex items-center w-full justify-between">
                                            <p className="text-sm text-gray-500 dark:text-gray-400">{contract.title}</p>
                                            <button
                                                onClick={() => navigate(`/dashboard/contracts/${contract.id}/view`)}
                                                className="bg-yellow-100 text-secondary text-[14px] px-3 rounded-md py-[2px]">
                                                View
                                            </button>
                                        </div>
                                        <p className="text-lg font-medium text-gray-800 dark:text-white">S. No. {contract.serial_no}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center">
                            <FaRegMoneyBillAlt className="mr-2 text-red-500" /> Sale Information
                        </h2>
                        <motion.div
                            className="bg-white/90 p-4 rounded-xl  border border-gray-100 dark:bg-gray-800 dark:border-gray-700"
                            whileHover={{ scale: 1.02 }}
                        >
                            <p className="text-lg font-medium text-gray-800 dark:text-white">
                                No sale information available.
                            </p>
                        </motion.div>
                    </div>
                )}
            </motion.div>
        </Layout>
    );
};

export default ViewProperty;
